import React from "react";
import { Button, Card, Form, Input } from "antd";
import { useAddDevice } from "../queries/device";
import { AddDeviceFormValues } from "../types/device";
import { useTitle } from "../hooks/useTitle";
import { useTranslation } from "react-i18next";
import { BackButton } from "../components/BackButton";

const AddDevicePage = () => {
  const { t } = useTranslation();

  useTitle(t("page-title.add-device"));
  const [form] = Form.useForm();
  const { mutate: connectDevice, isPending } = useAddDevice();

  const onFinish = (values: AddDeviceFormValues) => {
    connectDevice(values);
  };

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 500,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        marginTop: "2.5rem",
      }}
    >
      <Card title={t("pages.new-device.new-device")} style={{ width: 500 }}>
        <Form layout="vertical" onFinish={onFinish} form={form}>
          <Form.Item
            label={t("pages.new-device.code")}
            name="sixDigitCode"
            rules={[
              {
                required: true,
                message:
                  t("pages.new-device.code-required") || "Code is required",
              },
              {
                pattern: /^[0-9]{6}$/,
                message:
                  t("pages.new-device.code-must-be-6-digits") ||
                  "Code must be 6 digits",
              },
            ]}
          >
            <Input placeholder="000000" />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              style={{ float: "right" }}
              type="primary"
              htmlType="submit"
              loading={isPending}
            >
              {t("pages.new-device.validate-code")}
            </Button>
          </Form.Item>
        </Form>
      </Card>
      <BackButton />
    </div>
  );
};

export default AddDevicePage;
